<form>
  <ngx-intl-tel-input
    #tel_input
    [cssClass]="'custom'"
    [ngClass]="{ invalid: phoneControl.invalid && phoneControl.touched }"
    [preferredCountries]="preferredCountries"
    [enableAutoCountrySelect]="true"
    [enablePlaceholder]="true"
    [searchCountryFlag]="true"
    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="false"
    [selectedCountryISO]="activeCountryISO"
    [maxLength]="maxLength"
    [phoneValidation]="true"
    [separateDialCode]="true"
    [numberFormat]="PhoneNumberFormat.National"
    name="phone"
    [formControl]="phoneControl"
    [required]="required"
  >
  </ngx-intl-tel-input>
  <boels-limit-hint
    #limit_hint
    class="limit_hint"
    [maxLength]="maxLength"
    [valueLength]="tel_input.phoneNumber?.length"
  ></boels-limit-hint>
</form>
